import { getValidMainItemsSelector } from '../../../../services/validators/selectors/selectors';
import { Guid } from '../../../store/model/guid';
import { calculateIsLockedSelector } from '../calculateIsLocked';
import { ILinearModeData } from '../ItemsLockStatus/ILinearModeData';
import { Item, MainItem } from '@ael/core-api';
import * as Immutable from 'immutable';
import { createSelector } from 'reselect';


type LockStatus = {
  isLocked: boolean | undefined;
};

const calculateLinearModeData = (
  calculateIsLocked: (itemId: Guid, isLinearModeOn: boolean) => boolean,
  linearModeOn: boolean,
  allValidMenuItems: MainItem[]
): ILinearModeData => {
  if (!linearModeOn) {
    return {
      isInitialized: false,
      areAllUnlocked: false,
      getAllUnlocked(): Array<Guid> {
        return [];
      },
    };
  }

  const lockStatusesPerId = allValidMenuItems.reduce((acc, item: Item): Immutable.Map<Guid, LockStatus> => {
    const isLocked = calculateIsLocked(item.id, linearModeOn);

    return acc.set(item.id, { isLocked });
  }, Immutable.OrderedMap<Guid, LockStatus>());

  return {
    isInitialized: true,
    areAllUnlocked: lockStatusesPerId.every((value) => value?.isLocked === false),
    getAllUnlocked: (): Array<Guid> => {
      return lockStatusesPerId
          .filter((isLocked: LockStatus) => {
            return !isLocked.isLocked;
          })
          .map((_, id: Guid) => id)
          .toIndexedSeq()
          .toArray();
    },
  };
};

export const createLinearModeDataSelector = (isLinearModeOn: boolean) => {
  return createSelector(
    calculateIsLockedSelector,
    () => isLinearModeOn,
    getValidMainItemsSelector,
    calculateLinearModeData
  );
};
